<template>
  <div dir="rtl">
    <a v-if="!is_loaded" @click="load" class="button is-info is-outlined">טען את המידע של החברה</a>
    <div v-else>
      <div class="is-flex is-justify-content-space-between">
        <div>
          <button class="button is-outlined is-info" @click="companyEmployee">Company Employee</button>
          <button class="button is-outlined is-warning ml-2" @click="uploadContract">Upload Contract</button>
          <button class="button is-outlined is-primary ml-2" @click="viewCompanyOffers">הצעות החברה</button>
<PhoneCallButton :companyId="company_data.resource_id" />
        </div>
        <button class="button is-outlined is-success" @click="refreshCompanyData">
          <span class="icon">
            <i class="fas fa-sync-alt"></i>
          </span>
          <span>רענן נתונים</span>
        </button>
      </div>
      <div class="my-3">
        <SendingPolicyNotes :companyId="company_data.resource_id" />
      </div>
      <CompanyClassification :company="company_data" @updated="company_data = { ...company_data, ...$event }" />
      <p><b>Phone Number: </b>{{company_data.phone_number}}</p>
      <p><b>מצב שליחת קורות חיים דפולטיבי: </b>{{getCvSendingModeText(company_data.default_cv_sending_mode)}}</p>
      <div class="my-3">
        <p><b>ספר טלפונים:</b></p>
        <textarea v-model="phone_book" @blur="updatePhoneBook" class="textarea" rows="4" placeholder="הזן מספרי טלפון נוספים..."></textarea>
      </div>
      <div class="is-flex is-align-items-end">
        <ContactEmail
          v-model="contact_email"
          :companyId="company_data.resource_id"
        />
        <div class="horizontal_space"></div>
        <a @click="copyContactEmail" class="button mb-4 is-outlined is-info">Copy</a>
      </div>
      <p v-if="company_data.message != undefined && company_data.message.length > 0"><b>Message: </b> {{company_data.message}}</p>
      <location-editor :payload="{ location, resource_id: company_data.resource_id, resource_type: 'Company' }"></location-editor>
      <question-editor v-for="question in nearTrain" :key="question.id" :textClass="alertCSS(question)"
                       :payload="{ question: question, resource_type: 'Company', resource_id: company_data.resource_id }">
      </question-editor>
      <Checkbox class="my-2" v-model="isPanelActive" :checked="isPanelActive">is panel active</Checkbox>
      <question-editor v-for="question in questions" :key="question.id"
                       :payload="{ question: question, resource_type: 'Company', resource_id: company_data.resource_id }">
      </question-editor>
      <resource-text-editor :payload="{ text_data: texts.about_the_company, designator: 'about_the_company', resource_type: 'Company', resource_id: company_data.resource_id }">
      </resource-text-editor>
      <div v-if="company_positions.length > 0">
        <p><b>המשרות של החברה:</b></p>
        <div class="other_positions_container">
          <div v-for="company_position in company_positions" :key="company_position.id">
            <div class="is-flex is-align-items-center is-flex-wrap-wrap">
              <p><b>משרה: </b></p>
              <div style="width: 6px;"></div>
              <link-entity :payload="company_position" :additional_data="{ resource_type: 'Position' }"></link-entity>,
              <div style="width: 6px;"></div>
              <p><b>סטטוס: </b>{{company_position.status}}</p>,
              <div style="width: 6px;"></div>
              <p><b>הודעה: </b>{{company_position.message}}</p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <p><b>Internal Notes</b></p>
        <internal-notes :payload="company_data" :is_modal="false"></internal-notes>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TextsHelper from '@/custom/classes/texts_helper.js'
import TimeHelper from '@/custom/classes/time_helper.js'
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import PositionsHelper from '@/custom/classes/positions_helper.js'
import InternalNotes from '@/components/InternalNotes.vue'
import LinkEntity from '@/components/LinkEntity.vue'
import ResourceTextEditor from '@/components/ResourceTextEditor.vue'
import QuestionEditor from '@/components/QuestionEditor.vue'
import LocationEditor from '@/components/LocationEditor.vue'
import Checkbox from '@/components/Checkbox.vue'
import ContactEmail from './entities/company/ContactEmail.vue'
import PhoneCallButton from '@/components/PhoneCallButton.vue'
import SendingPolicyNotes from '@/components/SendingPolicyNotes.vue'
import CompanyClassification from '@/components/entities/company/CompanyClassification.vue'

export default {
  name: 'company-info',
  props: ['payload'],
  data () {
    return {
      is_loaded: false,
      texts_helper: new TextsHelper(),
      time_helper: new TimeHelper(),
      questions_helper: new QuestionsHelper(),
      positions_helper: new PositionsHelper(),
      company_data: this.payload.data,
      location: undefined,
      contact_email: this.payload.data.contact_email || '',
      phone_book: this.payload.data.phone_book || '',
      texts: {
        about_the_company: undefined
      },
      questions: [],
      nearTrain: [],
      company_positions: [],
      isPanelActive: false
    }
  },
  watch: {
    isPanelActive (newVal) {
      this.$network_utils.updateCompany({ id: this.payload.data.id, is_panel_active: newVal })
    }
  },
  methods: {
    load () {
      this.init()
      this.is_loaded = true
    },
    init () {
      this.isPanelActive = this.payload.data.is_panel_active
      this.getQuestions()
      this.getTexts()
      this.getLocation()
      this.getCompanyPositions()
    },
    alertCSS (question) {
      if (question.designator == 'has_contract') {
        const answer = this.questions_helper.getSingleAnswerText(question)
        return answer != 'Signed' ? 'has-text-danger' : ''
      }
      return ''
    },
    copyContactEmail () {
      if (this.texts_helper.getContent(this.texts).length == 0) {
        this.$utils.emit('show_toast', { text: 'contact_email ריק' })
        return
      }
      this.$utils.copyToClipboard(this.texts.contact_email.content)
      this.$utils.emit('show_toast', { text: 'contact_email הועתק למקלדת' })
    },
    uploadContract () {
      this.create({
        designator: 'upload-company-contract-modal',
        component_name: 'FilesCompanyContracts',
        company_id: this.company_data.resource_id,
        company_name: this.company_data.name,
        resource_id: this.company_data.resource_id,
        resource_type: this.company_data.resource_type,
        modal_width: 1600,
        modal_title: 'Upload contract for - ' + this.company_data.name
      })
    },
    companyEmployee () {
      this.create({
        designator: 'company-employees-manager',
        component_name: 'CompanyEmployeesManager',
        company_id: this.company_data.resource_id,
        modal_title: 'עובדי החברה - ' + this.company_data.name,
        modal_width: 1200
      })
    },
    viewCompanyOffers () {
      this.$router.push({
        name: 'company-offers-with-id',
        params: { company_id: this.company_data.resource_id }
      })
    },
    getQuestions () {
      this.$network_utils.getResourceQuestions({
        current_type: 'Company',
        current_resource_id: this.company_data.resource_id,
        designators: 'office_size,interview_score'
      }).then(response => {
        this.questions = response
      })
      this.$network_utils.getResourceQuestions({
        current_type: 'Company',
        current_resource_id: this.company_data.resource_id,
        designators: 'near_train,disable_automatic_company_response,is_send_one_file,has_contract'
      }).then(response => {
        this.nearTrain = response
      })
    },
    getTexts () {
      this.$network_utils.getResourceTexts({
        current_type: 'Company',
        current_resource_id: this.company_data.resource_id
      }).then(response => {
        this.setTexts(response)
      })
    },
    setTexts (texts) {
      for (let i = 0; i < texts.length; i++) {
        let text = texts[i]
        let designator = text.designator
        this.texts[designator] = text
      }
    },
    getLocation () {
      this.$network_utils.getResourceLocations({
        current_type: 'Company',
        current_resource_id: this.company_data.resource_id
      }).then(response => {
        this.location = response[0]
      })
    },
    getCompanyPositions () {
      this.$network_utils.getCompanyPositions({
        current_company_id: this.company_data.resource_id
      }).then(response => {
        this.company_positions = response
      })
    },
    getCvSendingModeText (mode) {
      switch (mode) {
        case 'normal':
          return 'רגיל (Normal)'
        case 'lite':
          return 'לייט (Lite)'
        case 'super_lite':
          return 'סופר לייט (Super Lite)'
      }
    },
    async updatePhoneBook () {
      try {
        await this.$network_utils.updateCompany({
          id: this.company_data.resource_id,
          phone_book: this.phone_book
        })

        // Update local data to reflect the changes
        this.company_data.phone_book = this.phone_book

        this.$utils.emit('show_toast', { text: 'ספר הטלפונים עודכן בהצלחה' })
      } catch (error) {
        this.$utils.emit('show_toast', { text: 'שגיאה בעדכון ספר הטלפונים' })
        console.error('Error updating phone book:', error)
      }
    },
    async refreshCompanyData () {
      try {
        const updatedCompany = await this.$network_utils.getCompany({ id: this.company_data.resource_id })

        // Update all company data with fresh data from server
        this.company_data = updatedCompany
        this.phone_book = updatedCompany.phone_book || ''
        this.contact_email = updatedCompany.contact_email || ''
        this.isPanelActive = updatedCompany.is_panel_active

        this.$utils.emit('show_toast', { text: 'נתוני החברה רוענו בהצלחה' })
      } catch (error) {
        this.$utils.emit('show_toast', { text: 'שגיאה ברענון נתוני החברה' })
        console.error('Error refreshing company data:', error)
      }
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    InternalNotes,
    LinkEntity,
    ResourceTextEditor,
    QuestionEditor,
    LocationEditor,
    Checkbox,
    ContactEmail,
    PhoneCallButton,
    SendingPolicyNotes,
    CompanyClassification
  }
}
</script>
<style scoped>
  .other_positions_container{
    background-color: #f9f9f9;
    max-height: 420px;
    overflow-y: auto;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1)
  }
</style>
